import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.css']
})
export class TermsOfUseComponent implements OnInit {

  public title: string;

  constructor(
    protected dialogRef: NbDialogRef<TermsOfUseComponent>
  ) {
    this.title = "Termos de uso";
   }

  ngOnInit(): void {
  }

  submit() {
    this.dialogRef.close(true);
  }

}
